/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `lt_23` - Less than or equal 23
 * * `gte_23` - Greater than 23
 */
export enum DriverAgeEnum {
  LT_23 = 'lt_23',
  GTE_23 = 'gte_23',
}
